import styled from "styled-components";

export const AccountingAccountWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;
